<template>
  <div>
    <div id="print-report">
      <!-- Print Only -->
      <HeaderPrint />
      <!-- / Print Only -->
      <v-card>
        <div class="pa-2">
          <v-row no-gutters class="align-center">
            <v-col cols="6" md="9">
              <v-btn
                small
                class="white black--text d-print-none"
                @click="$printReport()"
              >
                <v-icon small left>mdi-printer</v-icon>
                {{ $t("btnPrint") }}
              </v-btn>
            </v-col>
            <v-col cols="6" class="d-md-none">
              <div class="text-right d-print-none">
                <v-btn-toggle dense>
                  <v-btn @click="breakpoint = 0">
                    <v-icon>mdi-view-list</v-icon>
                  </v-btn>
                  <v-btn @click="breakpoint = 'xs'">
                    <v-icon>mdi-view-grid</v-icon>
                  </v-btn>
                </v-btn-toggle>
              </div>
            </v-col>
            <v-col cols="'12" md="3">
              <v-text-field
                v-model="search"
                :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : ''"
                append-icon="mdi-magnify"
                :label="$t('labelSearch')"
                single-line
                hide-details
                dense
                solo-inverted
                class="d-print-none"
                clearable
              ></v-text-field>
            </v-col>
          </v-row>
        </div>
        <v-data-table
          :headers="headers"
          :items="items"
          :search="search"
          :items-per-page="-1"
          hide-default-footer
          :mobile-breakpoint="breakpoint"
          :footer-props="{
            'items-per-page-text': this.$t('rowsPerPage'),
          }"
        >
          <template v-slot:item.id_agent="{ item }">
            <v-btn @click="$copy(item.id_agent)" x-small>{{
              item.id_agent
            }}</v-btn>
          </template>
          <template v-slot:item.count_sales="{ item }">
            <span class="caption">
              {{ item.count_sales }}
            </span>
          </template>
          <template v-slot:item.name_agent="{ item }">
            <a
              @click="
                $profile.showProfileDrawer(
                  item.id_agent,
                  'localManager/agents/getAgent'
                )
              "
            >
              <v-icon color="blue" x-small>mdi-account</v-icon>
              {{ item.name_agent }}
            </a>
          </template>

          <!-- VALUES -->
          <template
            v-for="(value, index) in valueColors"
            v-slot:[`item.${value}`]="{ item }"
          >
            <span class="caption" :key="index" :class="getColor(item[value])">{{
              item[value]
            }}</span>
          </template>

          <!-- ACTIONS -->
          <template v-slot:item.action="{ item }">
            <v-btn-toggle dense>
              <v-btn
                :title="$t('extractLabel')"
                small
                @click="openExtractDialog(item.id_agent, item.name_agent)"
              >
                <v-icon>mdi-receipt</v-icon>
              </v-btn>
            </v-btn-toggle>
          </template>
        </v-data-table>
      </v-card>
      <!-- Resume -->
      <div class="mt-4" v-if="items.length != 0">
        <v-row>
          <v-col v-if="$vuetify.breakpoint.smAndUp" sm="6" md="8"></v-col>
          <v-col cols="12" xs="12" sm="6" md="4">
            <v-card class="pa-3">
              <div class="subtitle-1 mb-2">
                {{ $t("periodSummary") }}
              </div>
              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                    <tr
                      v-for="(item, index) in keysResume"
                      :key="`${index} ${Math.random()}`"
                    >
                      <td class="caption">{{ TranslateKey(item) }}</td>
                      <td class="text-right" :class="resume[item].classColor">
                        {{ resume[item].value }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </div>

    <router-view :key="$route.fullPath"></router-view>

    <!-- Dialog Entry-->
    <v-dialog
      v-model="dialogEntry"
      width="600"
      persistent
      :fullscreen="$vuetify.breakpoint.xsOnly"
    >
      <v-toolbar>
        <v-toolbar-title>{{ $t("newLaunch") }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="dialogEntry = !dialogEntry"
          ><v-icon>mdi-close</v-icon></v-btn
        >
      </v-toolbar>
      <v-card> </v-card>
    </v-dialog>
  </div>
</template>
<script>
import HeaderPrint from "@/components/common/header-print";
export default {
  name: "local-manager-financial-agents-balance",
  components: {
    HeaderPrint,
  },
  data: () => ({
    breakpoint: "xs",
    dialogEntry: false,
    search: "",
    valueColors: [
      "previous_balance",
      "sales",
      "commission_sales",
      "cancellations",
      "prizes_paid",
      "balance",
    ],
    resume: null,
    keysResume: [],
    items: [],
    // props to dialog InsertEntryAgent:
    agent: "",
  }),

  computed: {
    headers() {
      return [
        { text: this.$t("idLabel"), value: "id_agent" },
        { text: this.$t("headersAgentName"), value: "name_agent" },
        { text: this.$t("previousBalance"), value: "previous_balance" },
        { text: this.$t("qtdLabel"), value: "count_sales" },
        { text: this.$t("sales"), value: "sales" },
        { text: this.$t("commissionSales"), value: "commission_sales" },
        { text: this.$t("cancellations"), value: "cancellations" },
        { text: this.$t("paidPrizes"), value: "prizes_paid" },
        // { text: this.$("deals"), value: "deals" },
        { text: this.$t("balance"), value: "balance" },
        {
          text: this.$t("actionsLabel"),
          value: "action",
          align: "center d-print-none",
          sortable: false,
        },
      ];
    },
  },
  mounted() {
    this.listBalance();
  },
  methods: {
    resetPage() {
      this.items = [];
      this.resume = null;
      this.search = "";
    },

    async listBalance() {
      this.resetPage();
      try {
        const response = await this.$request.get(
          "/localManager/financial/listBalance"
        );
        if (!response.dados) return;
        this.items = response.dados;
        this.buildResume(this.items);
      } catch (error) {
        console.log(error);
      }
    },

    buildResume(data) {
      if (!data) return;

      // SOMANDO
      const sum = (key) => {
        return data
          .map((item) => Number(item[key]))
          .reduce((a, b) => a + b, 0)
          .toFixed(2);
      };

      // CHAVES QUE DEVEM SER SOMADAS
      let resume = {
        previous_balance: {},
        sales: {},
        commission_sales: {},
        cancellations: {},
        prizes_paid: {},
        // deals: {},
        balance: {},
      };

      // CONSTRUINDO O OBJETO DE RESUMO
      Object.keys(resume).forEach((key) => {
        const total = sum(key);
        resume[key].value = `${total}`;
        resume[key].classColor = this.getColor(total);
      });

      // COMPLEMENTANDO COM QUANTIDADE
      const complement = {
        count_sales: { value: Number(sum("count_sales")) },
      };

      // ARMAZENANDO PARA EXIBIR NA UI
      this.resume = { ...complement, ...resume };
      this.keysResume = Object.keys(this.resume);
    },

    getColor(value) {
      if (value == 0) return "grey--text darken-4";
      if (value > 0) return "green--text";
      if (value < 0) return "red--text";
    },

    openExtractDialog(id_agent, name_agent) {
      // Open Route
      this.$router.push({
        name: "LocalManagerFinancialAgentsBalanceExtractAgent",
        params: { id_agent_extract: id_agent },
        query: { name_agent_extract: name_agent },
      }),
        // Open Dialog - Vuex
        this.$store.commit("showDialog", true);
    },
    TranslateKey: function(key) {
      const myKeysTranslated = {
        sales: this.$t("sales"),
        previous_balance: this.$t("previousBalance"),
        commission_sales: this.$t("commissionSales"),
        cancellations: this.$t("cancellations"),
        prizes_paid: this.$t("paidPrizes"),
        // deals: "Acertos",
        count_sales: this.$t("countSales"),
        balance: this.$t("balance"),
      };

      return myKeysTranslated[key] || null;
    },
  },
};
</script>
